import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { AlertEntity } from "src/app/features/Alert/types/AlertEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { statusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const AlertSearchForm: FC<SearchFormProps<AlertEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("alertSearchForm.criteriaBadges.pan")} name="pan">
                <TextInput name="pan" />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
        </SearchForm>
    );
};
